export const PROPERTY_ENDPOINT = '/property/v4'
